import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Container } from './styles';

const BackToTop = () => {
  const [visible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <Container onClick={() => scrollToTop()}>
      <FontAwesomeIcon icon="arrow-alt-circle-up" color="white" />
      <p>Back to top</p>
    </Container>
  );
};

export default BackToTop;
